import firebase from "firebase";

export class Tavolo {
    documentId: string;
    code: string;
    nome: string;
    posti: number;

    constructor() {
        this.documentId = "";
        this.code = "";
        this.nome = "";
        this.posti = 0;
    }

    static convertFromFirestore(documentId: string, object: firebase.firestore.DocumentData): Tavolo {
        let result: Tavolo = new Tavolo();
        result.documentId = documentId;
        result.code = object.code;
        result.nome = object.nome;
        result.posti = object.posti;
        return result;
    }

    static convertToFirestore(object: Tavolo): firebase.firestore.DocumentData {
        let result: firebase.firestore.DocumentData = {};
        result.code = object.code;
        result.nome = object.nome;
        result.posti = object.posti;
        return result;
    }
}